import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" La prórroga es la extensión del plazo de una licencia urbanística antes de su vencimiento. ")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "font-semibold mt-4" }, "Requisitos", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-6 mt-2" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Radicar la solicitud con documentación completa "),
    /*#__PURE__*/_createElementVNode("b", null, "30 días hábiles antes"),
    /*#__PURE__*/_createTextVNode(" del vencimiento.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Manifestación bajo juramento del inicio de obra por parte del urbanizador o constructor.")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "font-semibold mt-4" }, "Procedimiento", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, [
  /*#__PURE__*/_createTextVNode(" La solicitud se presenta ante el curador urbano, quien evalúa la documentación y, de ser procedente, concede una prórroga por hasta "),
  /*#__PURE__*/_createElementVNode("b", null, "12 meses"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)

import LicenceItem from "./LicenceItem.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LicenceItem, { title: 'Prórroga' }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5
    ]),
    _: 1
  }))
}
}

})